<template>
  <div class="container__reference-outline container__reference">
    <span class="header__reference">
      <b-img :src="iconCodiconBook" class="icon__codicon-book mr-2"> </b-img>
      <h5 class="font-weight-bold m-0">Reference</h5>
    </span>

    <div v-if="showButtonAddRef">
      <div id="tooitip-disabled-wrapper">
        <b-button
          id="button__add-method"
          class="w-100"
          variant="outline-primary"
          :disabled="isEditingMethod"
          @click="emitAddReference"
        >
          <font-awesome-icon
            class="icon__add"
            :icon="{ prefix: 'fas', iconName: 'plus' }"
            size="xs"
          />
          Add
        </b-button>

        <b-tooltip
          v-if="isEditingMethod"
          :placement="isLargeScreen ? `right` : `bottom`"
          triggers="hover"
          target="tooitip-disabled-wrapper"
          custom-class="tooltip__add-method"
          variant="light"
        >
          New topics can be added after the existing topic is finished.
        </b-tooltip>
      </div>
    </div>
    <div v-else class="text-primary">
      <div
        class="item__reference-outline"
        :class="{ 'selected-item__reference-outline': $selectedIndex === null }"
        @click="onChangeSelectItem"
      >
        Reference
      </div>
    </div>
  </div>
</template>

<script>
import codiconBookSvg from '@/assets/icon-method-component/codicon-book.svg';
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome';

export default {
  components: {
    FontAwesomeIcon
  },
  model: {
    prop: 'selectedIndex',
    event: 'update:selectedIndex'
  },
  props: {
    reference: {
      type: String,
      default: ''
    },
    selectedIndex: {
      type: Number,
      default: 0
    },
    mode: {
      type: String,
      required: true,
      validator: (value) => ['create', 'view', 'edit'].includes(value)
    },
    hasReference: {
      type: Boolean,
      default: false
    },
    isPublished: {
      type: Boolean,
      default: false
    },
    isOwner: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      iconCodiconBook: codiconBookSvg,
      methodOutline: [],
      isLargeScreen: false
    };
  },
  computed: {
    $selectedIndex: {
      get() {
        return this.selectedIndex;
      },
      set(newIndex) {
        this.$emit('update:selectedIndex', newIndex);
      }
    },
    selectedMethodComponentId() {
      return this.reference;
    },
    isEditingMethod() {
      return this.mode === 'edit' || this.mode === 'create';
    },
    isEditingReference() {
      return this.isEditingMethod && this.selectedIndex === null;
    },
    showButtonAddRef() {
      return this.isOwner && !this.hasReference && !this.isPublished && !this.isEditingReference;
    }
  },
  watch: {
    reference: {
      handler: function (val) {
        this.$emit('onSelectedItemId', val);
      },
      deep: true
    }
  },

  mounted() {
    this.initMethodOutline();
    this.updateView();

    window.addEventListener('resize', this.updateView);
  },

  beforeDestroy() {
    window.removeEventListener('resize', this.updateView);
  },

  methods: {
    updateView() {
      this.isLargeScreen = window.innerWidth > 768;
    },

    async initMethodOutline() {
      if (!this.reference) {
        this.$set(this.methodOutline, 0, {
          title: 'Introduction'
        });
      }
    },
    async addMethodOutline() {
      this.nextMethod();
      this.$emit('onAddItem', this.methodOutline);
    },
    onChangeSelectItem() {
      if (this.selectedIndex === null) {
        return;
      }
      const oldVal = this.selectedIndex;
      this.$emit('onSelectItem', { oldVal, newVal: null });
    },

    deleteMethod() {
      this.prevMethod();
    },
    nextMethod() {
      this.$emit('update:selectedIndex', this.$selectedIndex + 1);
    },
    prevMethod() {
      this.$emit('update:selectedIndex', this.$selectedIndex - 1);
    },
    emitAddReference() {
      this.$emit('addReference');
    },
    changeCancel() {
      this.$emit('update:selectedIndex', null);
    }
  }
};
</script>

<style lang="scss">
.container__reference-outline {
  --bg-geadient: linear-gradient(91.61deg, #667ce8 0%, #744ba3 100%);
  --dark-primary: #3b3e66;

  max-width: 340px;
  border: 1px solid #d1d2db;
  border-radius: 12px;
  padding: 20px;

  .selected-item__reference-outline {
    background: var(--bg-geadient);
    color: var(--white);
  }

  .header__reference {
    display: flex;
    padding-bottom: 20px;
    color: var(--dark-primary);
  }

  .item__reference-outline {
    font-weight: 600;
    cursor: pointer;
    border-radius: 4px;
    padding: 12px 16px;
  }

  .list__reference-outline {
    margin-bottom: 20px;
    list-style-type: none;
    padding: 0;
  }
}
// custom tooltip style
.tooltip__add-method {
  .arrow {
    border-color: #ffffff;
  }
  .tooltip-inner {
    background-color: #ffffff !important;
    max-width: 250px;
  }
}
</style>
